import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_table",
  "use": "icon-icon_table-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_table\">\n    <rect width=\"20\" height=\"20\" fill=\"white\" />\n    <path d=\"M18.3334 1.66602H1.66675V18.3327H18.3334V1.66602ZM3.33341 6.66602V3.33268H16.6667V6.66602H3.33341ZM3.33341 11.666V8.33268H16.6667V11.666H3.33341ZM3.33341 16.666V13.3327H16.6667V16.666H3.33341Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol